import Box from "glesys-controlpanel/components/box";
import GButtonEdit from "glesys-controlpanel/components/g-button/edit";
import GButtonCreate from "glesys-controlpanel/components/g-button/create";
import StatusIndicator from "glesys-controlpanel/components/status-indicator";

import canManage from "glesys-controlpanel/helpers/can-manage";
import modal from "glesys-controlpanel/helpers/modal";
import { on } from "@ember/modifier";
import { t } from "ember-intl";

<template>
  <Box data-test-server-scheduled-backups @showFooter={{(canManage)}} ...attributes>
    <:default>
      <p class="text-gray-500 text-sm">{{t "title.scheduled-backups"}}</p>

      <div class="text-2xl text-black mt-2 flex items-center gap-2" data-test-server-scheduled-backups-status>
        <StatusIndicator @status={{@server.backupStatusIndicator}} @showLabel={{true}} @size="large" />
      </div>
    </:default>
    <:footer>
      {{#if (canManage)}}
        {{#if @server.backup.enabled}}
          <GButtonEdit
            data-test-server-backup-configuration-button
            @type="button"
            @disabled={{@server.status.isLocked}}
            @display="compact"
            {{on "click" (modal "modals/kvm-edit-backup-configuration" server=@server project=@server.project)}}
          >
            {{t "server.details.backup.reconfigure"}}
          </GButtonEdit>
        {{else}}
          <GButtonCreate
            data-test-enable-backup
            @type="button"
            @disabled={{@server.status.isLocked}}
            @display="compact"
            {{on "click" (modal "modals/kvm-edit-backup-configuration" server=@server project=@server.project)}}
          >
            {{t "server.details.backup.enable"}}
          </GButtonCreate>
        {{/if}}
      {{/if}}
    </:footer>
  </Box>
</template>
